import styles from "./ops-room.module.scss"

// Images
import OperationsRoom from "../../../../assets/images/graphics/operations_room.png"

import { CosmosTitle } from "@cosmos/web-react"

// Returns the HTML markup for the ops room slide
export default function OpsRoom() {
	return (
		<>
			<div className={styles.container}>
				<CosmosTitle
					size="xx-large"
					className={styles.title}>
					OPERATIONS ROOM
				</CosmosTitle>

				<img
					className={styles.operations}
					src={OperationsRoom}
					alt="Operations Room"
				/>
			</div>
		</>
	)
}
